import React from 'react'

import ContainerDefault from '../../component/dashboard/Dashboard'

function Dashboard() {
  return (
    <div className='page-body'>
      <ContainerDefault />
    </div>
  )
}

export default Dashboard
